export const toDashboard = `/customer/account`
